/* eslint-disable @typescript-eslint/unbound-method */
import React from 'react';
import s from './ColorFilter.scss';

import type {IFilterOption} from '../../../../../types/galleryTypes';
import {ColorSampleGroup as ColorSampleGroupLegacy} from '@wix/wixstores-client-common-components/dist/es/src/ColorSampleGroup/ColorSampleGroup';
import {
  ColorSampleGroup as ColorSampleGroupNew,
  IColorSampleGroupOption,
} from '@wix/wixstores-client-storefront-common/components';
import _ from 'lodash';
import {withGlobals} from '../../../../../globalPropsContext';
import {IGalleryGlobalProps} from '../../../../galleryGlobalStrategy';
import {Experiments} from '../../../../../constants';

export interface IColorFilterProps extends IGalleryGlobalProps {
  colorOptions: IFilterOption[];
  showOptionName?: Function;
  filterId: number;
  selected: string[];
}

export enum ColorFilterDataHook {
  Wrapper = 'color-filter-wrapper',
}

class ColorFilterComp extends React.Component<IColorFilterProps> {
  public shouldComponentUpdate(nextProps) {
    return !_.isEqual(this.props.selected, nextProps.selected);
  }

  public render() {
    const {
      colorOptions,
      selected: controllerSelected,
      globals: {isRTL, useExperiments},
    } = this.props;
    const galleryColorPickerA11yReflowKeyboardFix = useExperiments.enabled(
      Experiments.GalleryColorPickerA11yReflowKeyboardFix
    );
    const useColorSampleGroupFromCommon = useExperiments.enabled(Experiments.GalleryUseColorSampleGroupFromCommon);
    const {shouldShowMobile} = this.props.globals;
    const options: IColorSampleGroupOption[] = colorOptions.map((option, i) => ({
      id: i,
      value: option.key,
      description: option.value,
    }));

    const selected = options.filter((option) => controllerSelected.includes(option.value));

    const ColorSampleGroup = useColorSampleGroupFromCommon ? ColorSampleGroupNew : ColorSampleGroupLegacy;

    return (
      <div className={s.colorList} data-hook={ColorFilterDataHook.Wrapper}>
        <ColorSampleGroup
          selected={selected as any}
          options={options}
          onMouseLeave={() => this.props.showOptionName('')}
          onMouseEnter={(value) => this.props.showOptionName(value)}
          onSelect={this.handleClick}
          allowMultiple={true}
          shouldFocus={galleryColorPickerA11yReflowKeyboardFix || !shouldShowMobile}
          isRTL={isRTL}
        />
      </div>
    );
  }

  private readonly handleClick = (selections: IColorSampleGroupOption[]) => {
    const selectedValue = _.xor(
      selections.map((option) => option.value),
      this.props.selected
    );
    this.props.globals.filterProducts(this.props.filterId, selectedValue[0]);
  };
}

export const ColorFilter = withGlobals(ColorFilterComp);
